import { Modify, OPTIMIZATION_TYPE } from '@bringg/types';
import { RoutesPlannerBreak } from '@bringg-frontend/routes-planner';
import { EtaResponseRouteItem } from '@bringg-frontend/eta-calculator';

export const USER_BASED_OPTIMIZATION_TYPES: OPTIMIZATION_TYPE[] = [
	OPTIMIZATION_TYPE.NAMED_PDP,
	OPTIMIZATION_TYPE.NAMED_VRP,
	OPTIMIZATION_TYPE.CREW_BASED,
	OPTIMIZATION_TYPE.COMBINED
];

type OptimizationRequestTask = {
	task_id?: number;
	id?: number;
	way_point_id: number;
	has_to_leave_by?: number;
	depot_etl?: number;
	eta: number;
	etl: number;
	priority: number;
	run_id?: number;
	user_id?: number;
	user_type_id?: number;
	driver_idx?: number;
	route_idx?: number;
	vehicle_id?: number;
};

type OptimizationRequestBreak = Modify<
	RoutesPlannerBreak,
	{
		scheduled_start_time: number;
		scheduled_end_time: number;
		estimated_start_time: number;
		estimated_end_time: number;
	}
>;

export enum OptimizationItemType {
	TASK = 'task',
	UNASSIGNED_TASK = 'unassigned_task',
	BREAK = 'actual_break',
	ROUTE_INFO = 'route_info'
}

export type ManualOptimizationItem<T extends OptimizationItemType = OptimizationItemType> = T extends
	| OptimizationItemType.TASK
	| OptimizationItemType.UNASSIGNED_TASK
	? { type: T } & OptimizationRequestTask
	: T extends OptimizationItemType.BREAK
	? { type: T } & OptimizationRequestBreak
	: T extends OptimizationItemType.ROUTE_INFO
	? { type: T } & EtaResponseRouteItem
	: never;
